// Home Text Content
export const FETCH_HOME_TEXT_CONTENT = 'FETCH_HOME_TEXT_CONTENT';

// Gallery
export const FETCH_GALLERY_LIST = 'FETCH_GALLERY_LIST';

// Footer
export const FETCH_FOOTER = 'FETCH_FOOTER';

// Events
export const FETCH_EVENTS_LIST = 'FETCH_EVENTS_LIST';

// Locations
export const FETCH_LOCATIONS_LIST = 'FETCH_LOCATIONS_LIST';

// Mobile Navigation
export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';
export const SET_TOGGLE_MOBILE_NAV = 'SET_TOGGLE_MOBILE_NAV';

// Auth
export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER';
export const FORCE_LOGOUT = 'FORCE_LOGOUT';
export const RESET_CURRENT_USER = 'RESET_CURRENT_USER';
export const SET_TOKEN = 'SET_TOKEN';

// Book Events
export const SET_CURRENT_BOOKING_EVENT = 'SET_CURRENT_BOOKING_EVENT';
export const SET_CURRENT_BOOKING_EVENT_ID = 'SET_CURRENT_BOOKING_EVENT_ID';

// My Events
export const GET_MY_EVENTS = 'GET_MY_EVENTS';
export const DELETE_AN_EVENT = 'DELETE_AN_EVENT';


// Counter
export const SET_EVENT_COUNTER = 'SET_EVENT_COUNTER';
